<!--
 * @Author: Latte
 * @Date: 2021-08-20 09:47:24
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-07 16:16:02
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\liveMgt\liveConfiguration\index.vue
-->
<template>
	<div class="app-container">
		<el-card>
			<div slot="header">修改直播间配置</div>
			<el-form ref="form" :model="formData" label-width="13vw" label-position="left">
				<el-form-item label="直播后台配置ID">
					<el-input v-model="formData.appConfigID" disabled></el-input>
				</el-form-item>
				<el-form-item label="直播创建权限">
					<el-radio-group v-model="formData.liveCreatePermission">
						<el-radio :label="0">无限制</el-radio>
						<el-radio :label="1">需授权</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="直播签到有效时长">
					<el-input-number v-model="formData.liveSignEffectiveTime"></el-input-number>
				</el-form-item>
				<el-form-item label="直播用户心跳间隔时间">
					<el-input-number v-model="formData.liveUserHeartDuration"></el-input-number>
				</el-form-item>
				<el-form-item label="最大允许直播可上麦观众数">
					<el-input-number v-model="formData.maxLiveAudienceSum"></el-input-number>
				</el-form-item>
				<el-form-item label="最大允许同时在线嘉宾数">
					<el-input-number v-model="formData.maxLiveGuestSum"></el-input-number>
				</el-form-item>
				<el-form-item label="最大允许直播正在上麦观众数">
					<el-input-number v-model="formData.maxLiveHasMicSum"></el-input-number>
				</el-form-item>
				<el-form-item label="最大允许同时直播数">
					<el-input-number v-model="formData.maxLiveSum"></el-input-number>
				</el-form-item>
				<el-form-item label="最大允许在线直播时长">
					<el-input-number v-model="formData.maxLiveTimeSpan"></el-input-number>
				</el-form-item>
        <el-form-item label="最大允许视频流数目">
          <el-input-number v-model="formData.maxLiveStreamSum"></el-input-number>
        </el-form-item>
				<el-form-item>
					<label slot="label">
						<el-button type="primary" size="medium" @click="save()">保存</el-button>
					</label>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import {
		getLiveConfig,
		setLiveConfig
	} from "@/api/mai/liveManagement/liveConfig";
	import {
		handleRes
	} from "@/utils/handleRes";
	import {
		printObj
	} from "@/utils/debug"
	export default {
		data() {
			return {
				formData: {},
			};
		},
		created() {
			this.refreshCurrentList();
		},
		methods: {
			/**
			 * 刷新列表
			 */
			refreshCurrentList() {
				this.getLiveBaseConfig();
			},
			/**
			 * 获得直播配置
			 */
			getLiveBaseConfig() {
				getLiveConfig().then((res) => {
					console.log(" -------------------------");
					console.log("getLiveConfig , res)", res);
					console.log(" -------------------------");
					this.formData = res.data;
				});
			},
			save() {
				const params = this.formData;
				printObj(params)
				setLiveConfig(params).then((res) => {
					console.log(" -----------------------");
					console.log("setLiveConfig , res", res);
					console.log(" -----------------------");
					handleRes(res);
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.el-input {
		width: 15vw;
	}
</style>
